var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.pax ? (_vm.pax.fname + ' ' + _vm.pax.lname) : ''}},[_c('div',{class:{
      slot: true,
      selectable: _vm.isSelectable,
      seat: _vm.isSeat,
      notSeat: !_vm.isSeat,
      unavailable: _vm.isUnavailable,
      occupied: _vm.occupied,
      seatSelected: _vm.isSelected
    },on:{"click":function($event){return _vm.$emit('select')}}},[_c('div',[_c('b-iconstack',[(_vm.isSeat && !_vm.occupied)?_c('b-icon',{attrs:{"stacked":"","icon":"person-plus-fill"}}):_vm._e(),(_vm.isSeat && _vm.occupied)?_c('b-icon',{attrs:{"stacked":"","icon":"x-circle-fill"}}):_vm._e(),(!_vm.isSeat)?_c('b-icon',{attrs:{"stacked":"","icon":"blank"}}):_vm._e()],1)],1),_c('div',[_c('small',[_c('strong',[_vm._v(_vm._s(_vm.label))])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }